import React, { useState, useEffect } from "react";
import { Row, Col, Table } from "react-bootstrap";
import CardHeader from "../../../components/CardHeader";
import TooltipHelper from "../../../components/TooltipHelper";
import { BASE_COLOR } from "../../../GlobalColors";

interface VariantsProps {
  data: App.Variant[];
  dataByWeek: Data.VariantsByWeek[];
}

export default function Variants({ data, dataByWeek }: VariantsProps) {
  const [sortedVariant, setSortedVariant] = useState<App.Variant[]>([]);
  useEffect(() => {
    setSortedVariant(
      data.sort((a, b) => b.sample_percentage - a.sample_percentage)
    );
  }, [data]);

  const additionalInfo = (
    <div className="text-right">
      <a
        href="./VariantDetails.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="font-weight-bold"
        style={{ color: BASE_COLOR }}
      >
        <i className="fas fa-file-pdf"></i> More Info on Variants
      </a>
    </div>
  );
  return (
    <Row>
      <Col>
        <div className="m-presumptive card">
          <CardHeader title="Variants" additionalInfo={additionalInfo} />
          <Row>
            <Col md={12} lg={12}>
              <Table>
                <thead>
                  <tr className="text-center bg-blue white">
                    <th className="text-left">Variant</th>
                    <th>
                      % of Samples <br />
                      (in current month)
                    </th>
                    <th>
                      Change in % of Samples <br />
                      (from previous month)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedVariant
                    .filter((variant) => variant.strain !== "All")
                    .map((variant) => (
                      <tr key={variant.strain}>
                        <td>
                          <strong>
                            {variant.origin}{" "}
                            {variant.origin.toLowerCase().indexOf("not") ===
                            0 ? (
                              <TooltipHelper
                                text={
                                  "The category “Not Variant of Concern” includes positive COVID-19 samples tested for a variant that either did not detect a variant strain or detected a variant of interest (like Epsilon/B.1.427/B.1.429) that has not been escalated to the classification of variant of concern."
                                }
                              />
                            ) : null}
                          </strong>{" "}
                          {variant.origin.toLowerCase().indexOf("not") === -1
                            ? `/ ${variant.strain}`
                            : null}
                        </td>
                        <td className="text-center">
                          {variant.sample_percentage}%
                        </td>
                        <td className="text-center">{variant.delta}%</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
}
